(function (IIA, $, window, document) {
  'use strict';
  // General Scripts
  var generalScripts = (function () {
    // Shared DOM references and runtime flags.
    var GLOBS = {
      searchToggle: document.getElementById('js-search-toggle'),
      searchWrap: document.getElementById('js-search'),
      visibleClass: 'is--visible',
      activeClass: 'is--active',
      mainNav: document.getElementById('js-nav'),
      navToggle: document.getElementById('js-nav-toggle'),
      isMobile: window.matchMedia ? window.matchMedia('(max-width:767px)').matches : false,
      $bannerSlider: $('#js-banner-slider'),
      $footerAccordion: $('.footer-accordion'),
      $footerAccordionToggle: $('.footer-accordion-toggle'),
      $filterForm: $('#filter-form'),
      $filterCbox: $('.filter-cbox'),
      $speakerAccordion: $('.speaker-accordion'),
      $speakerToggle: $('.speaker-toggle'),
      $dayAccordion: $('.day-accordion'),
      $dayToggle: $('.day-toggle'),
    };

    // General UI handlers.
    var handleSearchToggle = function () {
      var isOpen = GLOBS.searchToggle.classList.toggle(GLOBS.activeClass);
      GLOBS.searchWrap.classList.toggle(GLOBS.activeClass, isOpen);
      GLOBS.searchToggle.setAttribute('aria-expanded', String(isOpen));
    };
    var handleSearchNoClass = function () {
      GLOBS.searchToggle.classList.remove(GLOBS.activeClass);
      GLOBS.searchWrap.classList.remove(GLOBS.activeClass);
      GLOBS.searchToggle.setAttribute('aria-expanded', 'false');
    };
    var handleNavToggle = function (event) {
      var isOpen = GLOBS.mainNav.classList.toggle(GLOBS.activeClass);
      GLOBS.navToggle.classList.toggle(GLOBS.activeClass, isOpen);
      document.querySelector('body').classList.toggle('nav-active', isOpen);
      GLOBS.navToggle.setAttribute('aria-expanded', String(isOpen));
      GLOBS.navToggle.setAttribute('aria-label', isOpen ? 'Lukk meny' : 'Åpne meny');
      if (isOpen && event && event.detail === 0) {
        var firstItem = GLOBS.mainNav.querySelector('input, a, button');
        if (firstItem) {
          firstItem.focus();
        }
      }
    };
    var myIframe;
    var iframeSrc;

    // Initialize product view tracking.
    const initializeProductView = () => {
      function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        var expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + '; ' + expires + ';path=/';
      }
      function delete_cookie(name, path, domain) {
        if (get_cookie(name)) {
          document.cookie = name + '=' + (path ? ';path=' + path : '') + (domain ? ';domain=' + domain : '') + ';expires=Thu, 01 Jan 1970 00:00:01 GMT';
        }
      }
      function get_cookie(name) {
        return document.cookie.split(';').some(function (c) {
          return c.trim().indexOf(name + '=') === 0;
        });
      }
      if (document.querySelector('body').classList.contains('single-publikasjon') && typeof productID !== 'undefined') {
        setCookie('productViewed', productID);
      } else {
        delete_cookie('productViewed', '/');
      }
    };

    // Initialize download tracking.
    const initializeDownloadTracking = () => {
      $('.btn[download]').click(function (e) {
        if (typeof window.ga === 'function') {
          ga('send', 'event', 'Downloads', 'downloaded', $(this).data('title'), { transport: 'beacon' });
        }
      });
    };

    // Initialize anchor scrolling.
    const initializeAnchorScrolling = () => {
      $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .not('.woocommerce-tabs ul.tabs a, .wc-tabs-wrapper .wc-tabs a')
        .click(function (event) {
          // On-page links
          if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
              // Only prevent default if animation is actually gonna happen
              event.preventDefault();
              $('html, body').animate(
                {
                  scrollTop: target.offset().top,
                },
                1000,
                function () {
                  // Callback after animation
                  // Must change focus!
                  var $target = $(target);
                  $target.focus();
                  if ($target.is(':focus')) {
                    // Checking if the target was focused
                    return false;
                  } else {
                    $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                  }
                },
              );
            }
          }
        });
    };

    // Initialize video frame state used by popup handlers.
    const initializeVideoFrame = () => {
      if (document.querySelector('.video-wrap iframe')) {
        myIframe = document.querySelector('.video-wrap iframe');
        iframeSrc = myIframe.getAttribute('src');
      }
    };

    // Initialize the back-to-top control.
    const initializeGoTop = () => {
      // Back-to-top button.
      $('#gotop').click(function () {
        $('html, body').animate({ scrollTop: 0 }, 'slow');
        return false;
      });
      $(window).scroll(function () {
        if ($(window).scrollTop() > $('body').height() / 2) {
          $('#gotop').fadeIn();
        } else {
          $('#gotop').fadeOut();
        }
      });
    };

    // Initialize profile and search controls.
    const initializeProfileAndSearch = () => {
      // Profile controls.
      $('#profile-menu-toggle').click(function () {
        var isOpen = $('#profile-menu').toggleClass(GLOBS.activeClass).hasClass(GLOBS.activeClass);
        $(this).toggleClass(GLOBS.activeClass, isOpen).attr('aria-expanded', String(isOpen));
      });
      if (GLOBS.searchToggle) {
        GLOBS.searchToggle.addEventListener('click', handleSearchToggle);
      }
      var searchMask = document.querySelector('.search-mask');
      if (searchMask && GLOBS.searchToggle && GLOBS.searchWrap) {
        searchMask.addEventListener('click', function () {
          handleSearchNoClass();
        });
      }
    };

    // Initialize escape and popup close handling.
    const initializePopupClose = () => {
      // Escape key handling.
      document.onkeydown = function (evt) {
        evt = evt || window.event;
        var isEscape = false;
        if ('key' in evt) {
          isEscape = evt.key === 'Escape' || evt.key === 'Esc';
        } else {
          isEscape = evt.keyCode === 27;
        }
        if (isEscape) {
          handleSearchNoClass();
          if (GLOBS.navToggle && GLOBS.navToggle.classList.contains(GLOBS.activeClass)) {
            handleNavToggle();
            GLOBS.navToggle.focus();
          }
          if ($('#profile-menu').hasClass(GLOBS.activeClass)) {
            $('#profile-menu').removeClass(GLOBS.activeClass);
            $('#profile-menu-toggle').removeClass(GLOBS.activeClass).attr('aria-expanded', 'false').focus();
          }
          $('#js-video-popup').fadeOut(300);
          $('body').removeClass('popup-open');
          if (document.querySelector('.video-wrap iframe')) {
            myIframe.setAttribute('src', iframeSrc);
          }
        }
      };
      $('.close-popup').click(function () {
        $('#js-video-popup').fadeOut(300);
        $('body').removeClass('popup-open');
        if (document.querySelector('.video-wrap iframe')) {
          myIframe.setAttribute('src', iframeSrc);
        }
      });
    };

    // Initialize primary navigation.
    const initializeNavigation = () => {
      // Navigation toggle.
      if (GLOBS.navToggle && GLOBS.mainNav) {
        GLOBS.navToggle.addEventListener('click', handleNavToggle);
      }
    };

    // Initialize speaker and day accordions.
    const initializeSpeakerAccordions = () => {
      // Speaker accordion.
      GLOBS.$speakerToggle.children('button').click(function () {
        var $heading = $(this).parent();
        GLOBS.$speakerAccordion.not($heading.parent().next()).slideUp(300).removeClass(GLOBS.activeClass);
        GLOBS.$speakerToggle.not($heading).removeClass(GLOBS.activeClass).children('button').attr('aria-expanded', 'false');
        $heading.parent().next().slideToggle(300).toggleClass(GLOBS.activeClass);
        $heading.toggleClass(GLOBS.activeClass);
        $(this).attr('aria-expanded', String($heading.hasClass(GLOBS.activeClass)));
      });
      GLOBS.$dayToggle.children('button').click(function () {
        /* GLOBS.$dayAccordion
          .not($(this).next())
          .slideUp(300)
          .removeClass(GLOBS.activeClass);
        GLOBS.$dayToggle.not($(this)).removeClass(GLOBS.activeClass); */
        $(this).parent().next().slideToggle(300).toggleClass(GLOBS.activeClass);
        $(this).parent().toggleClass(GLOBS.activeClass);
        $(this).attr('aria-expanded', String($(this).parent().hasClass(GLOBS.activeClass)));
      });
    };

    // Initialize form field state and Gravity Forms callbacks.
    const initializeFormFields = () => {
      // Form input effects and interactions.
      $(document).on('change', '.details-form textarea, .details-form input', function () {
        var $this = $(this);
        if ($this.val() !== null && $this.val() !== '') {
          $this.parent().parent().addClass('has_text');
        } else {
          $this.parent().parent().removeClass('has_text');
        }
      });
      $(document).on('change', '.js-search input', function () {
        var $this = $(this);
        if ($this.val() !== null && $this.val() !== '') {
          $this.parent().parent().parent().addClass('has_text');
        } else {
          $this.parent().parent().parent().removeClass('has_text');
        }
      });
      function checkInputs() {
        $('.details-form input').each(function () {
          var $this = $(this);
          if ($this.val() !== null && $this.val() !== '') {
            $this.parent().parent().addClass('has_text');
          } else {
            $this.parent().parent().removeClass('has_text');
          }
        });
        $('.details-form textarea').each(function () {
          var $this = $(this);
          if ($this.val() !== null && $this.val() !== '') {
            $this.parent().parent().addClass('has_text');
          } else {
            $this.parent().parent().removeClass('has_text');
          }
        });
        $('.js-search input').each(function () {
          var $this = $(this);
          if ($this.val() !== null && $this.val() !== '') {
            $this.parent().parent().parent().addClass('has_text');
          } else {
            $this.parent().parent().parent().removeClass('has_text');
          }
        });
      }
      checkInputs();
      $(document).bind('gform_post_render', checkInputs);
      $(document).bind('gform_confirmation_loaded', function (event, formId) {
        if (formId === 6 || formId === 13) {
          var download_url = $('#generated-download-link').attr('href');

          if (download_url) {
            if (typeof window.ga === 'function') {
              ga('send', 'event', 'Downloads', 'downloaded', $('#generated-download-link').data('title'), { transport: 'beacon' });
            }

            var delay = 1000;
            setTimeout(function () {
              var win = window.open(download_url, '_blank');
              if (win && typeof win.focus === 'function') {
                win.focus();
              }
            }, 1);
          }
        }
      });

      $(document).on('focus', ' .input-wrap input', function () {
        var $this = $(this);
        $this.parent().addClass('has--focused');
      });

      $(document).on('blur', '.input-wrap input', function () {
        var $this = $(this);
        $this.parent().addClass('has--focused');
      });
      $(document).on('focus', '.details-form textarea, .details-form input', function () {
        var $this = $(this);
        $this.parent().parent().addClass('has--focused');
      });

      $(document).on('blur', '.details-form textarea, .details-form input', function () {
        var $this = $(this);
        $this.parent().parent().addClass('has--focused');
      });

      $(document).on('focus', '.js-search input', function () {
        var $this = $(this);
        $this.parent().parent().parent().addClass('has--focused');
      });

      $(document).on('blur', '.js-search input', function () {
        var $this = $(this);
        $this.parent().parent().parent().addClass('has--focused');
      });
    };

    // Initialize video popup trigger.
    const initializePopupTriggers = () => {
      $('.js-video-toggle').click(function () {
        $('#js-video-popup').fadeIn(300);
        $('body').addClass('popup-open');
        if (document.querySelector('.video-wrap iframe')) {
          myIframe.setAttribute('src', iframeSrc + '?autoplay=1');
        }
      });
      $('.close-search').click(function () {
        handleSearchNoClass();
        GLOBS.searchToggle.focus();
      });
    };

    // Initialize download form behavior.
    const initializeDownloadForm = () => {
      $(document).on('change', '.download-form input[type="radio"]', function (e) {
        if ($(this).attr('value') == 'Yes') {
          window.location.assign(loginURL);
        }
      });
    };

    // Initialize filters and print support.
    const initializeFilters = () => {
      // Filters.
      GLOBS.$filterCbox.click(function () {
        GLOBS.$filterForm.submit();
      });
      function printFnc() {
        window.print();
      }
    };

    // Expand sidebar submenus inline while keeping parent links usable.
    const initializeSidebarNavigation = () => {
      var duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 180;
      $('.side-links .menu-item-has-children').each(function (index) {
        var $item = $(this);
        var $link = $item.children('a').first();
        var $submenu = $item.children('.sub-menu').first();
        if (!$link.length || !$submenu.length) {
          return;
        }
        var submenuId = 'sidebar-submenu-' + index;
        var isOpen = $item.is('.current-menu-ancestor, .current-menu-parent, .current-menu-item');
        var $toggle = $('<button>', {
          type: 'button',
          class: 'side-links__toggle',
          'aria-controls': submenuId,
          'aria-expanded': String(isOpen),
          'aria-label': 'Undermeny: ' + $link.text().trim(),
        });
        $link.after($toggle);
        $submenu.attr('id', submenuId).prop('hidden', !isOpen);

        function setOpen(open) {
          $submenu.stop(true, true);
          $toggle.attr('aria-expanded', String(open));
          if (open) {
            $submenu.prop('hidden', false).hide().slideDown(duration);
          } else {
            $submenu.slideUp(duration, function () {
              $submenu.prop('hidden', true);
            });
          }
        }

        $toggle.on('click', function () {
          setOpen($toggle.attr('aria-expanded') !== 'true');
        });
        $item.on('keydown', function (event) {
          if (event.key === 'Escape' && $toggle.attr('aria-expanded') === 'true') {
            event.preventDefault();
            event.stopPropagation();
            setOpen(false);
            $toggle.focus();
          }
        });
      });
    };

    // Initialize mobile navigation and footer accordion.
    const initializeMobileNavigation = () => {
      // Mobile navigation and footer accordion.
      if (GLOBS.isMobile) {
        var $mobileMenuParents = $('.menu-item-has-children').not('.side-links .menu-item-has-children');
        $mobileMenuParents.click(function (e) {
          e.preventDefault();
          $(this).find(' > .sub-menu').slideToggle();
          $(this).toggleClass(GLOBS.activeClass);
          $(this)
            .children('a')
            .attr('aria-expanded', String($(this).hasClass(GLOBS.activeClass)));
        });
        $mobileMenuParents.children('a')
          .attr('aria-expanded', 'false')
          .on('keydown', function (e) {
            if (e.key === ' ') {
              e.preventDefault();
              $(this).click();
            }
          });
        $mobileMenuParents.find('.sub-menu a').click(function (e) {
          e.stopPropagation();
        });
        GLOBS.$footerAccordionToggle
          .attr('role', 'button')
          .attr('tabindex', '0')
          .attr('aria-expanded', 'false')
          .on('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              $(this).click();
            }
          })
          .click(function () {
            $(this).toggleClass(GLOBS.activeClass);
            $(this).next().slideToggle();
            $(this).attr('aria-expanded', String($(this).hasClass(GLOBS.activeClass)));
          });
      }
    };

    // Initialize cookie consent and iframe handling.
    const initializeCookies = () => {
      const cookieOverlay = document.getElementById('cookieOverlay');
      const cookieBanner = document.getElementById('cookieBanner');
      const cookieSettings = document.getElementById('cookieSettings');
      const strictlyNecessaryCookies = document.getElementById('strictlyNecessaryCookies');
      const functionalCookies = document.getElementById('functionalCookies');
      const analyticsCookies = document.getElementById('analyticsCookies');
      const marketingCookies = document.getElementById('marketingCookies');

      const acceptAll = document.getElementById('acceptAll');
      const rejectAll = document.getElementById('rejectAll');
      const customize = document.getElementById('customize');
      const savePreferences = document.getElementById('savePreferences');
      const backToMainBanner = document.getElementById('backToMainBanner');
      const changePreferences = document.getElementById('changeCookiePreferences');
      let hasTrackedAnalyticsPageView = false;

      if (
        cookieOverlay ||
        cookieBanner ||
        cookieSettings ||
        strictlyNecessaryCookies ||
        functionalCookies ||
        analyticsCookies ||
        marketingCookies ||
        acceptAll ||
        rejectAll ||
        customize ||
        savePreferences ||
        backToMainBanner
      ) {
        // Cookie-notice blockers (e.g. EasyList Cookie) hide #cookieBanner but not #cookieOverlay, which leaves the page covered and unusable.
        const releaseIfBannerBlocked = () => {
          if (cookieBanner.getAttribute('aria-hidden') === 'false' && !cookieBanner.getClientRects().length) {
            cookieOverlay.style.display = 'none';
            cookieOverlay.setAttribute('aria-hidden', 'true');
            cookieBanner.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('overflowHidden');
          }
        };

        const openCookieModal = () => {
          cookieOverlay.style.display = 'block';
          cookieOverlay.setAttribute('aria-hidden', 'false');
          cookieBanner.style.display = 'flex';
          cookieBanner.setAttribute('aria-hidden', 'false');
          cookieBanner.classList.remove('is-opening');
          // Force reflow so opening animation can replay consistently.
          void cookieBanner.offsetWidth;
          cookieBanner.classList.add('is-opening');
          document.body.classList.add('overflowHidden');
          cookieBanner.focus();
          releaseIfBannerBlocked();
        };

        const closeCookieModal = () => {
          toggleCookieDetails(false);
          cookieOverlay.style.display = 'none';
          cookieOverlay.setAttribute('aria-hidden', 'true');
          cookieBanner.style.display = 'none';
          cookieBanner.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('overflowHidden');
          if (changePreferences) {
            changePreferences.focus();
          }
        };

        const toggleCookieDetails = (isOpen) => {
          cookieBanner.classList.toggle('is-details-open', isOpen);
          cookieSettings.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
          customize.classList.toggle('hidden', isOpen);
          backToMainBanner.classList.toggle('hidden', !isOpen);
          rejectAll.classList.toggle('hidden', isOpen);
          acceptAll.classList.toggle('hidden', isOpen);
          savePreferences.classList.toggle('hidden', !isOpen);
          if (isOpen) {
            populateSettings();
          }
        };

        const triggerCookieNudge = () => {
          cookieBanner.classList.remove('is-nudging');
          // Force reflow so the animation can replay on repeated clicks.
          void cookieBanner.offsetWidth;
          cookieBanner.classList.add('is-nudging');
        };

        const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
        const isCookieModalOpen = () => cookieBanner.getAttribute('aria-hidden') === 'false';
        cookieBanner.addEventListener('animationend', function () {
          cookieBanner.classList.remove('is-nudging');
          cookieBanner.classList.remove('is-opening');
        });

        // Blockers may also hide the banner after it has been opened.
        if ('ResizeObserver' in window) {
          new ResizeObserver(releaseIfBannerBlocked).observe(cookieBanner);
        }

        cookieOverlay.addEventListener('click', function (e) {
          e.preventDefault();
          if (isCookieModalOpen()) {
            triggerCookieNudge();
          }
        });

        document.addEventListener('keydown', function (e) {
          if (!isCookieModalOpen()) {
            return;
          }

          if (e.key === 'Escape') {
            e.preventDefault();
            triggerCookieNudge();
            return;
          }

          if (e.key !== 'Tab') {
            return;
          }

          const focusables = Array.from(cookieBanner.querySelectorAll(focusableSelector)).filter((el) => el.offsetParent !== null);

          if (!focusables.length) {
            e.preventDefault();
            cookieBanner.focus();
            return;
          }

          const first = focusables[0];
          const last = focusables[focusables.length - 1];
          const activeElement = document.activeElement;
          const isFocusInsideModal = cookieBanner.contains(activeElement);

          if (!isFocusInsideModal) {
            e.preventDefault();
            if (e.shiftKey) {
              last.focus();
            } else {
              first.focus();
            }
            return;
          }

          if (e.shiftKey && activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        });

        if (!document.cookie.includes('privacy_popup')) {
          openCookieModal();
          toggleCookieDetails(false);
        }

        // "Accept All" button functionality
        acceptAll.addEventListener('click', function () {
          const consent = {
            strictlyNecessary: true,
            functional: true,
            analytics: true,
            marketing: true,
          };

          document.cookie = `privacy_popup=${encodeURIComponent(JSON.stringify(consent))}; path=/; max-age=31536000`;

          handleCookieConsent(consent);
          closeCookieModal();
        });

        // "Reject All" button functionality
        rejectAll.addEventListener('click', function () {
          const consent = {
            strictlyNecessary: true,
            functional: false,
            analytics: false,
            marketing: false,
          };

          document.cookie = `privacy_popup=${encodeURIComponent(JSON.stringify(consent))}; path=/; max-age=31536000`;

          handleCookieConsent(consent);
          closeCookieModal();
        });

        // "Customize" button functionality
        customize.addEventListener('click', function () {
          toggleCookieDetails(true);
        });

        // "Save Preferences" button functionality
        savePreferences.addEventListener('click', function () {
          const currentConsent = {
            strictlyNecessary: true,
            functional: functionalCookies.checked,
            analytics: analyticsCookies.checked,
            marketing: marketingCookies.checked,
          };

          document.cookie = `privacy_popup=${encodeURIComponent(JSON.stringify(currentConsent))}; path=/; max-age=31536000`;

          handleCookieConsent(currentConsent);
          closeCookieModal();
        });

        // "Back to Main Banner" button functionality
        backToMainBanner.addEventListener('click', function () {
          toggleCookieDetails(false);
        });

        // "Change Preferences" button functionality
        if (changePreferences) {
          changePreferences.addEventListener('click', function (e) {
            e.preventDefault();
            openCookieModal();
            toggleCookieDetails(false);
          });
        }

        // Populate the settings based on saved consent
        function populateSettings() {
          const savedConsent = getSavedConsent();
          if (savedConsent) {
            strictlyNecessaryCookies.checked = true;
            functionalCookies.checked = !!savedConsent.functional;
            analyticsCookies.checked = !!savedConsent.analytics;
            marketingCookies.checked = !!savedConsent.marketing;
          }
        }

        // Retrieve saved consent from the cookie
        function getSavedConsent() {
          const cookieValue = getCookie('privacy_popup');
          if (cookieValue) {
            try {
              return JSON.parse(cookieValue);
            } catch (e) {
              console.error('Error parsing JSON from cookie:', e);
            }
          }
          return {
            strictlyNecessary: true,
            functional: false,
            analytics: false,
            marketing: false,
          };
        }

        // Get cookie value
        function getCookie(name) {
          const value = `; ${document.cookie}`;
          const parts = value.split(`; ${name}=`);
          if (parts.length === 2) {
            try {
              return decodeURIComponent(parts.pop().split(';').shift());
            } catch (e) {
              console.error('Error decoding cookie:', e);
              return null;
            }
          }
          return null;
        }

        function handleCookieConsent(consent) {
          if (typeof window.gtag === 'function') {
            gtag('consent', 'update', {
              ad_personalization: consent.marketing ? 'granted' : 'denied',
              ad_storage: consent.marketing ? 'granted' : 'denied',
              ad_user_data: consent.marketing ? 'granted' : 'denied',
              analytics_storage: consent.analytics ? 'granted' : 'denied',
              functionality_storage: consent.functional ? 'granted' : 'denied',
              personalization_storage: consent.functional ? 'granted' : 'denied',
              security_storage: 'granted',
            });
            gtag('set', 'ads_data_redaction', consent.marketing ? false : true);

            if (consent.analytics && !hasTrackedAnalyticsPageView) {
              gtag('event', 'page_view', {
                page_title: document.title,
                page_path: window.location.pathname,
              });
              hasTrackedAnalyticsPageView = true;
            }
          }
          if (!consent.analytics) {
            hasTrackedAnalyticsPageView = false;
          }

          handleIframes(consent);
          try {
            const consentCookie = JSON.stringify(consent);
            document.cookie = `privacy_popup=${encodeURIComponent(consentCookie)}; path=/; max-age=31536000; Secure; SameSite=Lax`;
          } catch (error) {
            console.error('Error setting cookie:', error);
          }
        }

        // iFrame Cookie handle
        function handleIframes(consent) {
          var iframes = document.querySelectorAll('iframe[data-src]');
          Array.prototype.forEach.call(iframes, function (iframe) {
            var dataSrc = iframe.getAttribute('data-src');
            if (dataSrc && (dataSrc.indexOf('youtube') !== -1 || dataSrc.indexOf('vimeo') !== -1 || dataSrc.indexOf('google') !== -1)) {
              var parent = iframe.parentNode;
              var consentMessage = parent.querySelector('.cookieContentDisable');
              if (!consentMessage) {
                consentMessage = document.createElement('div');
                consentMessage.className = 'cookieContentDisable generalContent';
                consentMessage.innerHTML =
                  '<p>For å se dette innholdet, må du godta informasjonskapsler. Informasjonskapsler hjelper oss med å laste inn innholdet riktig og gi deg en bedre opplevelse.</p>';
                parent.insertBefore(consentMessage, iframe);
              }
              if (consent.analytics && consent.marketing) {
                iframe.src = iframe.getAttribute('data-src');
                iframe.style.display = 'block';
                consentMessage.style.display = 'none';
              } else {
                iframe.removeAttribute('src');
                iframe.style.display = 'none';
                consentMessage.style.display = 'block';
              }
            }
          });
        }

        // Initial Consent Handling
        const cookieValue = getCookie('privacy_popup');
        if (cookieValue) {
          try {
            const consent = JSON.parse(cookieValue);
            // console.log('Initial consent:', consent);
            handleCookieConsent(consent);
          } catch (e) {
            console.error('Error parsing JSON from cookie:', e);
          }
        } else {
          // Handle iFrames if cookie banner isn't set yet.
          handleIframes({
            strictlyNecessary: true,
            functional: false,
            analytics: false,
            marketing: false,
          });
        }
      }
    };

    // Initialize the desktop/home banner slider.
    const initializeBannerSlider = () => {
      if (typeof GLOBS.$bannerSlider.owlCarousel === 'function') {
        GLOBS.$bannerSlider.owlCarousel({
          items: 1,
          nav: false,
          navText: ['<span class="screen-reader-text">Forrige</span>', '<span class="screen-reader-text">Neste</span>'],
          animateOut: 'fadeOut',
          touchDrag: false,
          dots: true,
          loop: true,
          autoplay: true,
          autoplayTimeout: 7000,
          autoplayHoverPause: true,
          responsiveClass: true,
          responsive: {
            0: {
              touchDrag: true,
              nav: true,
            },
            767: {
              touchDrag: false,
              nav: false,
            },
          },
        });
        GLOBS.$bannerSlider.find('.owl-dot').each(function (index) {
          $(this).attr('aria-label', 'Gå til lysbilde ' + (index + 1));
        });
      }
    };

    // Initialize Gravity Forms select enhancements.
    const initializeFormChoices = () => {
      //Choice
      /*   if (document.querySelector(".js-select")) {
        var choices = new Choices(".js-select select", {
          searchEnabled: false,
          searchChoices: false,
          itemSelectText: ""
        });
      }

      function reInitChoices() {
        if (document.querySelector(".js-select")) {
          var choices = new Choices(".js-select select", {
            searchEnabled: false,
            searchChoices: false,
            itemSelectText: ""
          });
        }
      } */
      // if (document.querySelector('.gfield_select ')) {
      //   var choices = new Choices('.gfield_select', {
      //     searchEnabled: false,
      //     searchChoices: false,
      //     itemSelectText: '',
      //   });
      // }

      function reInitChoices() {
        if (document.querySelector('.gfield_select ') && typeof window.Choices === 'function') {
          var choices = new Choices('.gfield_select', {
            searchEnabled: false,
            searchChoices: false,
            itemSelectText: '',
          });
        }
      }
      $(document).bind('gform_post_render', reInitChoices);
    };

    // Initialize company lookup autocomplete.
    const initializeCompanyAutocomplete = () => {
      /* $(".doc-form form").submit(function () {
        $(".gfield_radio").parent().parent().addClass("has-title");
      }); */
      if (document.querySelector('.js-search input') && window.axios && window.Awesomplete) {
        axios
          .get('https://data.brreg.no/enhetsregisteret/enhet.json')
          .then(function (response) {
            // handle success
            return response.data.data;
          })
          .then(function (data) {
            // handle success
            var list = data.map(function (i) {
              return { label: i.navn, value: i };
            });
            var companyNumbers = data.map(function (i) {
              return i.organisasjonsnummer;
            });
            var autoSearch = new Awesomplete(document.querySelector('.js-search input'), {
              list: list,
            });
            document.querySelector('.js-search input').addEventListener('awesomplete-selectcomplete', function (item) {
              var result = item.text.value;
              $('.js-search input').val(result.navn);
              $('.js-land input').val(result.forretningsadresse.land).parent().parent().addClass('has_text');
              $('.js-address input').val(result.forretningsadresse.adresse).parent().parent().addClass('has_text');
              $('.js-postnumer input').val(result.forretningsadresse.postnummer).parent().parent().addClass('has_text');
              $('.js-poststed input').val(result.forretningsadresse.poststed).parent().parent().addClass('has_text');
              $('.js-faktura input').val(result.organisasjonsnummer).parent().parent().addClass('has_text');
            });
          })
          .catch(function (error) {
            // handle error
            console.log(error);
          });
      }
    };

    // Initialize mobile-only sliders.
    const initializeMobileSlider = () => {
      if (GLOBS.isMobile) {
        $('.mobile-slider').addClass('owl-carousel');
        if (typeof $('.mobile-slider').owlCarousel === 'function') {
          $('.mobile-slider').owlCarousel({
            items: 1,
            dots: false,
            nav: true,
            navText: ['<span class="screen-reader-text">Forrige</span>', '<span class="screen-reader-text">Neste</span>'],
          });
        }
      }
    };

    const initializeGeneral = () => {
      [
        initializeProductView,
        initializeDownloadTracking,
        initializeAnchorScrolling,
        initializeVideoFrame,
        initializeGoTop,
        initializeProfileAndSearch,
        initializePopupClose,
        initializeNavigation,
        initializeSpeakerAccordions,
        initializeFormFields,
        initializePopupTriggers,
        initializeDownloadForm,
        initializeFilters,
        initializeSidebarNavigation,
        initializeMobileNavigation,
        initializeCookies,
      ].forEach((initialize) => initialize());
    };

    const initializeFinal = () => {
      [initializeBannerSlider, initializeFormChoices, initializeCompanyAutocomplete, initializeMobileSlider].forEach((initialize) => initialize());
    };

    return {
      init: initializeGeneral,
      finalize: initializeFinal,
    };
  })();

  // IIA Main
  const iiaJS = {
    init() {
      generalScripts.init();
    },
    finalize() {
      generalScripts.finalize();
    },
  };
  window.iiaJS = iiaJS;

  // Document ready
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      iiaJS.init();
      iiaJS.finalize();
    },
    false,
  );
})((window.IIA = window.IIA || {}), window.jQuery, window, document);
